import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { CartListURL, Post } from "../utils/api";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
const menus = [
  {
    label: "Shop",
    submenu: [
      { label: "Shop Products", icon: "", navigate: "/home" },
      { label: "Shop Bundles", icon: "", navigate: "/home" },
    ],
  },
  {
    label: "Why us?",
    submenu: [
      { label: "Our Mission", icon: "", navigate: "/home" },
      { label: "Our Ingredients", icon: "", navigate: "/home" },
      { label: "Our Experts", icon: "", navigate: "/home" },
      { label: "About Us", icon: "", navigate: "/aboutus" },
    ],
  },
  {
    label: "Learn more",
    submenu: [
      { label: "Blog", icon: "", navigate: "/home" },
      { label: "Faqs", icon: "", navigate: "/home" },
      { label: "Refund policy", icon: "", navigate: "/home" },
      { label: "Shipping policy", icon: "", navigate: "/home" },
      { label: "Privacy policy", icon: "", navigate: "/home" },
      { label: "Terms of service", icon: "", navigate: "/home" },
    ],
  },
  {
    label: "Subscribe",
    submenu: [
      { label: "My Account", icon: "", navigate: "/home" },
      { label: "Join Newsletter", icon: "", navigate: "/home" },
    ],
  },
  { label: "Contact us", icon: "", navigate: "/home" },
];

const Header = ({ cartClick = () => {} }) => {
  const [showDropdown, setshowdropdown] = useState("");

  const navigate = useNavigate();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const [ad, showad] = useState(true);
  const { userinfo, cartItems } = useSelector((state) => state);
  const [searchkey, setsearchkey] = useState();
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      // onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>
        <div>
          {menus?.map((value, index) => (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                {/* {(value?.navigate)? */}
                <div
                  style={{
                    background: "#e6e6e6",
                    borderBottom: "1.5px solid black",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <button
                    style={{
                      height: "50px",
                      borderRadius: "0px",
                      paddingLeft: "10px",
                      background: "#e6e6e6",
                    }}
                    className="accordion-button collapsed"
                    type="button"
                    onClick={() => {
                      value.navigate
                        ? navigate(value.navigate)
                        : showDropdown && value.label == showDropdown
                        ? setshowdropdown("")
                        : setshowdropdown(value.label);
                    }}
                  >
                    {value?.label}
                  </button>
                  <div
                    style={{
                      paddingRight: "10px",
                    }}
                  >
                    <img
                      src={"/images/expand_more.png"}
                      style={{
                        transform:
                          showDropdown == value.label
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        height: "25px",
                        width: "25px",
                      }}
                    />
                  </div>
                </div>
              </h2>
              {value.label == showDropdown && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // minHeight:'300px',
                    }}
                  >
                    {value?.submenu?.map((v, i) => (
                      <div
                        onClick={() => {
                          navigate(v.navigate);
                        }}
                        style={{
                          borderBottom: "1.5px solid black",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            alignItems: "center",
                            display: "flex",
                            minHeight: "50px",
                            borderRadius: "0px",
                            paddingLeft: "10px",
                          }}
                        >
                          {v.label}
                        </div>
                        <div>
                          <img
                            src={"/images/arrow.png"}
                            style={{
                              marginRight: "10px",
                              height: "17px",
                              width: "17px",
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
          <Divider style={{ border: "1px solid #000000" }} />
        </div>
      </List>
    </Box>
  );

  useEffect(() => {
    fetchCartList();
  }, []);

  const fetchCartList = () => {
    global.Loader(true);
    let config = {
      url: CartListURL,
    };
    Post(config)
      .then((res) => {
        global.Loader(false);
        if (res.status == true) {
          global.dispatch({
            type: "CARTITEMS",
            payload: res?.data,
          });
        }
      })
      .catch((err) => {
        global.Loader(false);
       // console.log(err?.response?.data);
      });
  };

  return (
    <div className="best">
      {ad == true && (
        <header className="text-center text-white p-1 dummy">
          <div className="container">
            <p>Use code HEALTHFIRST and get 10% off on all orders</p>
          </div>
        </header>
      )}

      <nav className="navbar navbox navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <div className="logo logo_span">
            <div className="col-md-12">
              <div className="logo">
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle"
                    style={{ border: "0px" }}
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i
                      className="fa-solid fa-bars"
                      style={{ fontSize: "26px" }}
                    ></i>
                  </button>

                  <a
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    <img
                      src="https://amhara.in/images/logo.png"
                      className="logo-image"
                    />
                  </a>
                  <ul
                    className="dropdown-menu"
                    style={{
                      marginLeft: "-13px",
                      width: "1366px",
                      // width: '1350px',
                      marginleft: "0px",
                      backgroundColor: "#FFFFFF",
                      // borderBottom: '2px solid #ddd !important',
                      borderBottom: "2px solid #ddd",
                    }}
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <div
                      className="slim"
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        padding: "21px",
                      }}
                    >
                      <div className="plusone ">
                        <li>
                          <h2
                            style={{
                              color: "#219653",
                              fontSize: "16px",
                            }}
                          >
                            Shop
                          </h2>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/shoppage"
                          >
                            Shop Products
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/shoppage"
                          >
                            Shop Bundles
                          </a>

                          <h2
                            className="subscribe"
                            style={{
                              color: "#219653",
                              fontSize: "16px",
                              marginTop: "10px",
                            }}
                          >
                            Subscribe
                          </h2>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/dashboard"
                          >
                            My Account
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Join Newsletter
                          </a>
                        </li>
                      </div>
                      <div className="plusone two">
                        <li>
                          <h2
                            style={{
                              color: "#219653",
                              fontSize: "16px",
                            }}
                          >
                            Why us?
                          </h2>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Our Mission
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/ingredents"
                          >
                            Our Ingredients
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Our Experts
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/aboutus"
                          >
                            About Us
                          </a>
                        </li>
                      </div>
                      <div className="plusone three">
                        <li>
                          <h2
                            style={{
                              color: "#219653",
                              fontSize: "16px",
                            }}
                          >
                            Learn more
                          </h2>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Blog
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            FAQs
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Refund policy
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Shipping policy
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/privacy-policy"
                          >
                            Privacy policy
                          </a>
                          <a
                            className="dropdown-item"
                            style={{
                              fontSize: "16px",
                              padding: "5px 0px",
                            }}
                            href="/404"
                          >
                            Terms of service
                          </a>
                        </li>
                      </div>
                      <div className="of_service">
                        <img
                          src="/images/slim.png"
                          alt=""
                          style={{
                            height: "346px",
                            width: "468px",
                          }}
                        />
                      </div>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        style={{ position: "absolute", right: "15px" }}
                      ></button>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        paddingBottom: "10px",
                        marginTop: "20px",
                        justifyContent: "space-between",
                        backgroundColor: "white",
                        alignItems: "end",
                      }}
                    >
                      <div className="links">
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/facebook1.png"
                            alt=""
                          />
                        </a>
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/twtter.png"
                            alt=""
                          />
                        </a>
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/instagram.png"
                            alt=""
                          />
                        </a>
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/Pinterest.png"
                            alt=""
                          />
                        </a>
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/youtube.png"
                            alt=""
                          />
                        </a>
                        <a href="#" style={{ marginLeft: "10px" }}>
                          <img
                            style={{
                              width: "40px",
                              border: "4px solid #fff",
                              borderRadius: "50%",
                              padding: "0",
                              boxShadow: "0px 3px 3px -1px",
                              color: "#000",
                            }}
                            src="/images/linkedin.png"
                            alt=""
                          />
                        </a>
                      </div>
                      <div className="care">
                        <a
                          href="#"
                          style={{
                            textDecoration: "none",
                            marginRight: "25px",
                            marginLeft: "100px",
                            color: "#219653",
                            fontSize: "19px",
                          }}
                        >
                          care@zeonutra.com
                        </a>
                        <a
                          style={{
                            textDecoration: "none",
                            marginRight: "25px",
                            marginLeft: "100px",
                            color: "#219653",
                            fontSize: "19px",
                          }}
                          href="#"
                        >
                          +91-00000-00000
                        </a>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>

            {/* <React.Fragment key={'left'}>
                    <Button onClick={toggleDrawer('left', true)} style={{fontSize:'21px'}}><i className="fa-solid fa-bars"></i></Button>
                    <Drawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                    >
                        {list('left')}
                    </Drawer>
                    </React.Fragment> */}
            {/* <a href="/home">
                            <img src="/images/logo.png" />
                        </a> */}
            <span className="headerSpan">
              <div
                className="reach1"
                onClick={() => {
                  if (searchkey != "") {
                    //    navigate(`/shoppage/${searchkey}`)
                  }
                }}
              >
                <img src={"/images/search1.png"} className="fa fa-search" />
                {/* abhishek  */}
                <input
                  onKeyPress={(e) => {
                    if (e.key === "Enter" && searchkey != "") {
                      navigate(`/shoppage/${searchkey}`);
                    }
                  }}
                  onChange={({ target }) => {
                    setsearchkey(target.value);
                  }}
                  type="search"
                  value={searchkey}
                  placeholder="Search Product"
                />
              </div>
              <Link>
                <img src={"/images/whatsapp.png"} />
              </Link>
              <div className="reach">
                <i className="fa fa-search" aria-hidden="true"></i>
              </div>
              {userinfo?.token && (
                <Link to={"/dashboard"}>
                  <img src={"/images/profile.png"} />
                </Link>
              )}
              {userinfo?.token && (

                <div onClick={cartClick}>
                  <i
                    style={{ marginTop: "4px", marginLeft: "8px" }}
                    className="fa-solid fa-bag-shopping"
                  >
                    {cartItems?.length > 0 && (
					
                      <p
                        style={{
                          fontSize: "8px",
                          position: "absolute",
                          backgroundColor: "red",

                          padding: "5px",
                          borderRadius: "23px",
                          paddingRight: "6px",
                          paddingLeft: "6px",
                          zIndex: "999",
                          top: "10px",
                          marginLeft: "13px",
                        }}
                      >
                        {cartItems?.length}

                      </p>
                    )}
                  </i>
                </div>
              )}
              {userinfo?.token && <div className="lavian"></div>}
            </span>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
